// extracted by mini-css-extract-plugin
export default {"content":"HomeContent_content__ecKrx","actions":"HomeContent_actions__MfP0q","quickNavigation":"HomeContent_quickNavigation__klWIt","icon":"HomeContent_icon__DXffn"};